<template>
  <div class="home">
    <el-card shadow="always">
      <el-page-header
        @back="goBack"
        content="Perfil do Usuário"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        label-position="top"
        label-width="100px"
        ref="formRules"
        :model="formRules"
        :rules="rules"
      >
        <el-form-item label="Nome" prop="name">
          <el-input ref="name" v-model="formRules.name"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="mail">
          <el-input type="email" v-model="formRules.mail" disabled></el-input>
        </el-form-item>

        <el-form-item label="Senha atual" prop="oldPassword">
          <el-input
            v-model="formRules.oldPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="Nova senha" prop="newPassword">
          <el-input
            v-model="formRules.newPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="Confirme nova senha" prop="confirmPassword">
          <el-input
            v-model="formRules.confirmPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="update()">
            <i class="el-icon-check"></i>&nbsp;Atualizar
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { UserService } from "../services/users/user.services";
export default {
  name: "ProfileView",
  components: {},
  data() {
    const checkPassword = (rule, value, callback) => {
      const vm = this;
      if (vm.formRules.oldPassword && !value) {
        return callback(new Error("Informe a nova senha"));
      }
      callback();
    };
    const checkDouble = (rule, value, callback) => {
      const vm = this;
      if (vm.formRules.oldPassword) {
        if (!value) {
          return callback(new Error("Confirme sua nova senha"));
        }
        if (vm.formRules.newPassword !== value) {
          return callback(new Error("As senhas devem ser iguais!"));
        }
      }
      callback();
    };
    return {
      id: "",
      formRules: {
        name: "",
        mail: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Informe um nome",
            trigger: "blur",
          },
        ],
        newPassword: [{ validator: checkPassword, trigger: "blur" }],
        confirmPassword: [{ validator: checkDouble, trigger: "blur" }],
      },
    };
  },
  methods: {
    goBack: function () {
      const vm = this;
      vm.$router.push({ name: "home" });
    },
    update: function () {
      const vm = this;
      this.$refs.formRules.validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          UserService.profile(
            vm.formRules.name,
            vm.formRules.newPassword,
            vm.formRules.oldPassword
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: "Perfil atualizado com sucesso!",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.formRules.name = response.user.name;
        vm.formRules.mail = response.user.mail;
        vm.$refs.name.$el.children[0].focus();
      })
      .catch((error) => {
        vm.$router.push({ name: "home" });
      });
  },
};
</script>
